export function formatStringToInt(str: string): number {
  return +str.replaceAll(' ', '').replaceAll(',', '.');
}
